import { computed, onMounted, ref } from 'vue';
import { useI18n } from '@/composables';
import { getDictionaryApiRequest } from '@/services/api/dictionary-api';

type ThreePanelCategory = {
  name: string;
  selected: boolean;
  picked: boolean;
  data: unknown;
};

type FlowThreePanelDictionaryOptions = {
  apiKey: string;
  prefix: string;
  title: string;
  name: string;
  withVersionPredicates?: boolean;
};

export const useFlowThreePanelDictionaryCondition = (
  options: FlowThreePanelDictionaryOptions,
) => {
  const { t } = useI18n();

  const data = ref<ThreePanelCategory[]>([]);
  const loading = ref(false);

  const predicates = computed(() => {
    if (!options.withVersionPredicates) return undefined;

    return [
      { value: 'EQUALS', label: t('Equals') },
      { value: 'NOT_EQUALS', label: t('Not equal') },
      { value: 'LOWER_OR_EQUALS', label: t('Lower or equals') },
      { value: 'HIGHER_OR_EQUALS', label: t('Higher or equals') },
    ];
  });

  onMounted(() => {
    loading.value = true;
    getDictionaryApiRequest(options.apiKey, {}).then((result) => {
      const dictionaryResult = result as Record<string, unknown>;
      data.value = Object.keys(dictionaryResult).map((key) => ({
        name: key,
        selected: false,
        picked: false,
        data: dictionaryResult[key],
      }));
      loading.value = false;
    });
  });

  return {
    t,
    data,
    loading,
    predicates,
    prefix: options.prefix,
    title: options.title,
    name: options.name,
  };
};
